import angular from 'angular';

export const vrmWhitelabelModule = angular.module('vrm.whitelabel', []);

angular.module('vrm.whitelabel')
    .service("WhitelabelService", WhitelabelService);

// Dynamic stylesheet loading, vue.config.js modifies the webpack build to compile the whitelabels and emit them as stylesheets.
// Performing an import in this context simply returns the absolute url to the imported resource in the output path.
// E.g. ecube.less -> /adcde3456543456.css
const whitelabelUrls = (() => {
    try {
        return require.context('@/styles/whitelabels/', false, /\.less/);
    } catch {
        return (name) => {
            throw new Error(`Whitelabels disabled, trying to load: ${name}`);
        };
    }
})();

/**
 * @constructor
 * @ngInject
 */
function WhitelabelService($rootScope, $log, AppearanceService, vrmThemes) {

    /* Public */
    var currentWhitelabel = false;

    return {
        setWhitelabel: setWhitelabel,
        getGraphColors: getGraphColors,
        getMarkerSprite: getMarkerSprite
    };


    function getMarkerSprite() {
        switch (currentWhitelabel && currentWhitelabel.name) {
            case 'OceanVolt': return '/img/whitelabels/oce-vrm-markers.png';
            case 'Offgrid Energy': return '/img/whitelabels/oge-vrm-markers.png';
            case 'Energy Solutions': return '/img/whitelabels/es-vrm-markers.png';
            case 'Smartflower': return '/img/whitelabels/sf-vrm-markers.png';
            default: return '/img/vrm-markers.png';
        }
    }

    function getGraphColors() {
        const isDarkMode = AppearanceService.isDarkModeActive();
        const black = isDarkMode ? '#faf9f5' : '#000000';
        const darkGrey = isDarkMode ? '#faf9f5' : '#504f4b'
        switch (currentWhitelabel && currentWhitelabel.name) {
            case "OceanVolt": return {
                'orange': '#f7ab3e',
                'red': '#fa716f',
                'blue': '#4790d0', // '#000c78', Replaced with the standard color since unreadable in dark-mode,
                'darkBlue': '#1066B1',
                'green': '#8bc964',
                'black': black,
                'grey': '#64635f',
                'darkGrey': darkGrey,
                'indigo': '#9683ec',
                'magenta': '#E18EE9',
                'cyan': '#0FC0D8',
                'lightPink': '#E97A83',
                'lightRed': '#fcb8b7',
                'lightBlue': '#a3c7e7',
                'lightBlue2': '#6eb3f0',
                'lightBlue3': '#b0c6f7',
                'lightOrange': '#fbd59e',
                'lightGreen': '#c5e4b1',
                'lightGrey': '#969591',
                'lightIndigo': '#c3b8f5',
                'transparent': 'rgb(255, 255, 255, 0)',
                'lightBlue4': '#6097D1',
                'lightBlue5':'#598BBE'
            };
            case "Offgrid Energy": return {
                'orange': '#f8941d',
                'red': '#ee1a3b',
                'blue': '#4790d0', // '#0054a6', Replaced with the standard color since unreadable in dark-mode
                'darkBlue': '#1066B1',
                'green': '#0db14b',
                'black': isDarkMode ? '#DCDBD7' : '#121114',
                'grey': '#64635f',
                'darkGrey': darkGrey,
                'indigo': '#9683ec',
                'magenta': '#E18EE9',
                'cyan': '#0FC0D8',
                'lightPink': '#E97A83',
                'lightRed': '#e40c20',
                'lightBlue': '#a3c7e7',
                'lightBlue2': '#6eb3f0',
                'lightBlue3': '#b0c6f7',
                'lightOrange': '#f68115',
                'lightGreen': '#0ba33f',
                'lightGrey': '#969591',
                'lightIndigo': '#c3b8f5',
                'transparent': 'rgb(255, 255, 255, 0)',
            };
            case "Energy Solutions": return {
                'orange': '#f7ab3e',
                'red': '#fa716f',
                'blue': '#4790d0', // '#004990', Replaced with the standard color since unreadable in dark-mode
                'darkBlue': '#1066B1',
                'green': '#00a1b1',
                'black': isDarkMode ? '#DCDBD7' : '#333333',
                'grey': '#64635f',
                'darkGrey': darkGrey,
                'indigo': '#9683ec',
                'magenta': '#E18EE9',
                'cyan': '#0FC0D8',
                'lightPink': '#E97A83',
                'lightRed': '#f35c58',
                'lightBlue': '#a3c7e7',
                'lightBlue2': '#6eb3f0',
                'lightBlue3': '#b0c6f7',
                'lightOrange': '#f0962e',
                'lightGreen': '#008fa1',
                'lightGrey': '#969591',
                'lightIndigo': '#c3b8f5',
                'transparent': 'rgb(255, 255, 255, 0)',
            };
            case "Smartflower": return {
                'orange': '#d2ad2b',
                'red': '#bc3c8e',
                'blue': '#0098a0',
                'darkBlue': '#1066B1',
                'green': '#2f872a',
                'black': black,
                'grey': '#64635f',
                'darkGrey': darkGrey,
                'indigo': '#9683ec',
                'magenta': '#E18EE9',
                'cyan': '#0FC0D8',
                'lightPink': '#E97A83',
                'lightRed': '#ad2e7b',
                'lightBlue': '#a3c7e7',
                'lightBlue2': '#6eb3f0',
                'lightBlue3': '#b0c6f7',
                'lightOrange': '#c79c20',
                'lightGreen': '#24741f',
                'lightGrey': '#969591',
                'lightIndigo': '#c3b8f5',
                'transparent': 'rgb(255, 255, 255, 0)',
            };
            case "Powercore": return {
                'orange': '#f7ab3e',
                'red': '#fa716f',
                'blue': '#00c0f3',
                'darkBlue': '#1066B1',
                'green': '#8bc964',
                'black': black,
                'grey': '#64635f',
                'darkGrey': darkGrey,
                'indigo': '#9683ec',
                'magenta': '#E18EE9',
                'cyan': '#0FC0D8',
                'lightPink': '#E97A83',
                'lightRed': '#fcb8b7',
                'lightBlue': '#a3c7e7',
                'lightBlue2': '#6eb3f0',
                'lightBlue3': '#b0c6f7',
                'lightOrange': '#fbd59e',
                'lightGreen': '#c5e4b1',
                'lightGrey': '#969591',
                'lightIndigo': '#c3b8f5',
                'transparent': 'rgb(255, 255, 255, 0)',
            };
            case "Ascot": return {
                'orange': '#f7ab3e',
                'red': '#C00D0D',
                'blue': '#00c0f3',
                'darkBlue': '#1066B1',
                'green': '#8bc964',
                'black': isDarkMode ? '#dadada' : '#333132',
                'grey': '#64635f',
                'darkGrey': darkGrey,
                'indigo': '#9683ec',
                'magenta': '#E18EE9',
                'cyan': '#0FC0D8',
                'lightPink': '#E97A83',
                'lightRed': '#fcb8b7',
                'lightBlue': '#a3c7e7',
                'lightBlue2': '#6eb3f0',
                'lightBlue3': '#b0c6f7',
                'lightOrange': '#fbd59e',
                'lightGreen': '#c5e4b1',
                'lightGrey': '#969591',
                'lightIndigo': '#c3b8f5',
                'transparent': 'rgb(255, 255, 255, 0)',
            };
            case "SO energy": return {
                'orange': '#ffe478',
                'red': '#ff8652',
                'blue': '#00c0f3',
                'darkBlue': '#1066B1',
                'green': '#8bc964',
                'black': '#DCDBD7',
                'grey': '#64635f',
                'darkGrey': darkGrey,
                'indigo': '#9683ec',
                'magenta': '#E18EE9',
                'cyan': '#0FC0D8',
                'lightPink': '#E97A83',
                'lightRed': '#dc6f41',
                'lightBlue': '#a3c7e7',
                'lightBlue2': '#6eb3f0',
                'lightBlue3': '#b0c6f7',
                'lightOrange': '#ecce54',
                'lightGreen': '#c5e4b1',
                'lightGrey': '#969591',
                'lightIndigo': '#c3b8f5',
                'transparent': 'rgb(255, 255, 255, 0)',
            };
            case "TryStar": return {
                'orange': '#E0A700',
                'red': '#E42D02',
                'blue': '#00ACE5',
                'darkBlue': '#1066B1',
                'green': '#79C318',
                'black': '#1C1C1C',
                'grey': '#606060',
                'darkGrey': darkGrey,
                'indigo': '#9683ec',
                'magenta': '#E18EE9',
                'cyan': '#0FC0D8',
                'lightPink': '#E97A83',
                'lightRed': '#EF9C95',
                'lightBlue': '#8FE2EF',
                'lightBlue2': '#6eb3f0',
                'lightBlue3': '#b0c6f7',
                'lightOrange': '#F4D590',
                'lightGreen': '#C6E585',
                'lightGrey': '#8E9093',
                'lightIndigo': '#c3b8f5',
                'transparent': 'rgb(255, 255, 255, 0)',
            }
            // case "Pure Drive Energy storage": return {
            //     'orange': '#ffe478',
            //     'red': '#ff8652',
            //     'blue': '#00c0f3',
            //     'green': '#8bc964',
            //     'black': '#DCDBD7',
            //     'grey': '#64635f',
            //     'indigo': '#9683ec',
            //     'lightRed': '#dc6f41',
            //     'lightBlue': '#a3c7e7',
            //     'lightBlue2': '#6eb3f0',
            //     'lightBlue3': '#b0c6f7',
            //     'lightOrange': '#ecce54',
            //     'lightGreen': '#c5e4b1',
            //     'lightGrey': '#969591',
            //     'lightIndigo': '#c3b8f5',
            // };
            // UNDP uses default colors so is skipped here
            default: return {
                'orange': '#F7AB3E',
                'red': '#FA717F',
                'blue': '#4790D0',
                'darkBlue': '#1066B1',
                'green': '#8BC964',
                'black': black,
                'grey': '#64635F',
                'darkGrey': darkGrey,
                'indigo': '#9683EC',
                'magenta': '#E18EE9',
                'cyan': '#0FC0D8',
                'lightPink': '#E97A83',
                'lightRed': '#FCB8B7',
                'lightBlue': '#A3C7E7',
                'lightBlue2': '#6EB3F0',
                'lightBlue3': '#B0C6F7',
                'lightOrange': '#FBD59E',
                'lightGreen': '#C5E4B1',
                'lemonGreen': '#D4DE5F',
                'lightGrey': '#969591',
                'lightIndigo': '#C3B8F5',
                'lightPurple': '#EEB1F4',
                'transparent': 'rgb(255, 255, 255, 0)',
            }
        }
    }

    function setWhitelabel(whitelabel) {
        // Used in whitelabels
        $rootScope.defaultLogo = "img/victron_logo_white.svg";
        $rootScope.defaultLogoRGB = "img/victron_logo_rgb.svg";

        if (AppearanceService.isChristmasThemeActive()) {
            document.body.classList.add('christmas-theme');
        } else if (AppearanceService.isEasterThemeActive()) {
            document.body.classList.add('easter-theme');
        } else if (AppearanceService.isSummerThemeActive()) {
            document.body.classList.add('summer-theme');
        }

        currentWhitelabel = false;

        if (whitelabel && whitelabel.stylesheet) {
            $log.info('Setting whitelabel to: ' + whitelabel.name);
            let whiteLabelClass = whitelabel.name.toLowerCase().replaceAll(' ', '-');
            document.documentElement.classList.add(whiteLabelClass);
            $rootScope.whiteLabelClass = whiteLabelClass;
            $rootScope.logo = "img/whitelabels/" + whitelabel.stylesheet.replace('.less', '-diap.svg');
            $rootScope.logoRGB = "img/whitelabels/" + whitelabel.stylesheet.replace('.less', '-rgb.svg');

            currentWhitelabel = whitelabel;
        }
        else {
            document.documentElement.classList.remove($rootScope.whiteLabelClass);
            $rootScope.logo = $rootScope.defaultLogo;
            $rootScope.logoRGB = $rootScope.defaultLogoRGB;
        }

        $rootScope.$emit("whitelabelChanged");
    }
}
